"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Quantity = _interopRequireDefault(require("../../Molecules/Quantity"));
var _Price = _interopRequireDefault(require("../../Molecules/Price"));
var _Divider = _interopRequireDefault(require("../../Atoms/Divider"));
var _SKURestrictedTiles = _interopRequireDefault(require("./SKURestrictedTiles"));
var _Notification = _interopRequireDefault(require("../../Atoms/Notification"));
var _common = require("../../../core/utils/common");
var _SKUTiles = require("./SKUTiles.constant");
var _SKUTiles2 = require("./SKUTiles.utils");
var SKUTilesBuyInfo = function SKUTilesBuyInfo(_ref) {
  var _product$stock;
  var productItem = _ref.productItem,
    labels = _ref.labels,
    config = _ref.config,
    _updateCartQuantity = _ref.updateCartQuantity,
    isUserLoggedIn = _ref.isUserLoggedIn,
    basePriceValue = _ref.basePriceValue,
    disabled = _ref.disabled,
    isObsoleteDiscontinued = _ref.isObsoleteDiscontinued,
    isObsoleteDiscontinuedWithReplacement = _ref.isObsoleteDiscontinuedWithReplacement,
    isUnavailableProduct = _ref.isUnavailableProduct,
    isSKUUnbuyable = _ref.isSKUUnbuyable,
    isUnavailableItem = _ref.isUnavailableItem,
    includeTaxWithPrice = _ref.includeTaxWithPrice;
  var product = productItem.product,
    quantity = productItem.quantity,
    entryNumber = productItem.entryNumber,
    _productItem$isFreeGi = productItem.isFreeGift,
    isFreeGift = _productItem$isFreeGi === void 0 ? false : _productItem$isFreeGi,
    _productItem$isFreePr = productItem.isFreeProduct,
    isFreeProduct = _productItem$isFreePr === void 0 ? false : _productItem$isFreePr;
  var code = product.code,
    sKUPageUrl = product.sKUPageUrl,
    name = product.name,
    _product$purchasable = product.purchasable,
    purchasable = _product$purchasable === void 0 ? false : _product$purchasable,
    productReferences = product.productReferences,
    _product$addToCartDis = product.addToCartDisabled,
    addToCartDisabled = _product$addToCartDis === void 0 ? false : _product$addToCartDis,
    _product$hsnCode = product.hsnCode,
    hsnCode = _product$hsnCode === void 0 ? '' : _product$hsnCode;
  var _labels$hsnLabel = labels.hsnLabel,
    hsnLabel = _labels$hsnLabel === void 0 ? '' : _labels$hsnLabel;
  var stockLevelStatus = (0, _lodash.get)(product, 'stock.stockLevelStatus', '');
  var isStockDataEnabled = !!(product != null && (_product$stock = product.stock) != null && _product$stock.stockLevelStatus);
  var stockLevel = (0, _lodash.get)(product, ['stock', 'stockLevel'], '');
  var restockDate = (0, _lodash.get)(product, 'stock.restockDate', '');
  var shippingDate = (0, _lodash.get)(product, 'stock.shippingDate', '');
  var additionalInfo = (0, _lodash.get)(product, 'stock.additionalInfo', '');
  var priceLabels = isUserLoggedIn ? labels.yourPrice : labels.listPrice;
  var customerPriceValue = (0, _SKUTiles2.getCustomerPriceValue)(productItem, includeTaxWithPrice);
  var isFreeItem = isFreeGift || isFreeProduct;
  var formatShippingDate = (0, _SKUTiles2.convertDate)(shippingDate, (0, _SKUTiles2.getLocale)());
  var formatRestockDate = (0, _SKUTiles2.convertDate)(restockDate, (0, _SKUTiles2.getLocale)());
  var price = "" + basePriceValue;
  if (isUserLoggedIn && typeof customerPriceValue.formattedValue !== 'undefined') {
    price = "" + customerPriceValue.formattedValue;
  }
  var getTitleDescription = function getTitleDescription(condition, primary, secondary) {
    return condition ? primary : secondary;
  };
  var getPartialInStock = function getPartialInStock() {
    if (stockLevelStatus === _SKUTiles.outOfStock) {
      return _react.default.createElement(_Notification.default, {
        className: "out-of-stock-notification",
        variation: "small",
        title: getTitleDescription(additionalInfo, '', labels.contactWaters),
        description: getTitleDescription(additionalInfo, labels.estimatedShipDates, labels.forAvailability),
        elementLocator: "out-of-stock"
      });
    }
    if (stockLevelStatus === _SKUTiles.temporarilyOutOfStock) {
      return _react.default.createElement(_Notification.default, {
        className: "out-of-stock-notification",
        variation: "small",
        title: getTitleDescription(restockDate, '', labels.contactWaters),
        description: getTitleDescription(restockDate, labels.estimatedToShip + " " + formatRestockDate, labels.forAvailability),
        elementLocator: "temp-out-of-stock"
      });
    }
    if (stockLevelStatus === _SKUTiles.partialInStock && restockDate !== '') {
      return _react.default.createElement(_Notification.default, {
        className: "partial-stock-notification",
        variation: "small",
        title: getTitleDescription(shippingDate, '', labels.partialStock),
        description: getTitleDescription(shippingDate, stockLevel + " " + labels.estimatedToShip + " " + formatShippingDate, (0, _common.getLabelWithParam)(labels.partialStockAvailable, [stockLevel])),
        restDescription: getTitleDescription(shippingDate, quantity - stockLevel + " " + labels.estimatedToShip + " " + formatRestockDate, ''),
        icon: getTitleDescription(shippingDate, '', config.unavailableIconUrl),
        elementLocator: "partial-stock"
      });
    }
    if (stockLevelStatus === _SKUTiles.partialInStock && restockDate === '') {
      return _react.default.createElement(_Notification.default, {
        className: "partial-stock-notification",
        variation: "small",
        title: getTitleDescription(shippingDate, '', labels.partialStock),
        description: getTitleDescription(shippingDate, stockLevel + " " + labels.estimatedToShip + " " + formatShippingDate, (0, _common.getLabelWithParam)(labels.partialStockAvailable, [stockLevel])),
        restDescription: getTitleDescription(shippingDate, labels.remaingShipDates, ''),
        icon: getTitleDescription(shippingDate, '', config.unavailableIconUrl),
        elementLocator: "partial-stock"
      });
    }
    return _react.default.createElement(_Notification.default, {
      className: "in-stock-notification",
      variation: "small",
      title: getTitleDescription(shippingDate, '', labels.inStock),
      description: getTitleDescription(shippingDate, labels.estimatedToShip + " " + formatShippingDate, labels.orderNow),
      icon: getTitleDescription(shippingDate, '', config.successIconUrl),
      elementLocator: "in-stock"
    });
  };
  var skuTileClassName = hsnCode && !isUnavailableProduct ? 'col-lg-9' : 'col-lg-12';
  return _react.default.createElement("div", {
    className: "col-xs-12 col-md-6 skutile-buyinfo",
    "data-locator": "sku-tiles-buy-info-container"
  }, !isUnavailableProduct && _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12 col-sm-12 " + skuTileClassName + " sku-tile-buy"
  }, _react.default.createElement("div", {
    className: "skutile-qty"
  }, _react.default.createElement(_Quantity.default, (0, _extends2.default)({
    id: code + "-quantity",
    placeholder: labels.qtyPlaceholder,
    value: quantity,
    disabled: disabled || isFreeItem,
    isFreeItem: isFreeItem,
    elementLocator: "input-sku-tiles-update-quantity"
  }, {
    updateCartQuantity: function updateCartQuantity(value) {
      return _updateCartQuantity({
        code: code,
        quantity: value,
        entry: entryNumber,
        productName: name,
        sKUPageUrl: sKUPageUrl
      });
    } // eslint-disable-next-line react/jsx-curly-newline
  }))), _react.default.createElement("div", null, _react.default.createElement(_Price.default, {
    isCustomerPrice: isUserLoggedIn,
    labels: priceLabels,
    price: price,
    elementLocator: "sku-tiles-price"
  }), _react.default.createElement("div", {
    className: "stock-availability-mobile-view"
  }, isStockDataEnabled && getPartialInStock())), isStockDataEnabled && _react.default.createElement(_Divider.default, {
    type: "v-large",
    elementLocator: "divider-sku-tiles-large"
  }), isStockDataEnabled && (0, _SKUTiles2.getStockAvailability)(productItem, labels, config)), hsnCode && _react.default.createElement("div", {
    className: "col-xs-12 col-sm-12 col-lg-3 hsn-code-section",
    "data-locator": "hsn-code"
  }, hsnLabel + " " + hsnCode)), isUnavailableProduct && _react.default.createElement(_SKURestrictedTiles.default, {
    purchasable: purchasable,
    addToCartDisabled: addToCartDisabled,
    isObsoleteDiscontinued: isObsoleteDiscontinued,
    isObsoleteDiscontinuedWithReplacement: isObsoleteDiscontinuedWithReplacement,
    labels: labels,
    config: config,
    productReferences: productReferences,
    isSKUUnbuyable: isSKUUnbuyable,
    isUnavailableItem: isUnavailableItem
  }));
};
SKUTilesBuyInfo.defaultProps = {
  productItem: {},
  labels: {},
  config: {},
  updateCartQuantity: function updateCartQuantity() {
    /* default updateCartQuantity handler */
  },
  isUserLoggedIn: false,
  disabled: false,
  basePriceValue: '',
  isObsoleteDiscontinued: false,
  isObsoleteDiscontinuedWithReplacement: false,
  isUnavailableProduct: false,
  isSKUUnbuyable: false,
  isUnavailableItem: false,
  includeTaxWithPrice: false
};
var _default = SKUTilesBuyInfo;
exports.default = _default;
module.exports = exports["default"];